// extracted by mini-css-extract-plugin
export default {"heroImage":"HeroImage_heroImage__ZVZDx"};